module.exports = __webpack_public_path__ + "img/monterey-g-series-front-angle.488e4223.png";